import * as React from 'react';
import { useEffect, useState } from 'react';
import type { TextInput } from 'react-native';
import { useClickOutside } from 'react-native-click-outside';
import {
    BodyMediumRegular,
    StyledBodyMediumRegularInput,
    XStack,
    YStack,
} from 'smoothie';

import {
    formatCurrencyInputOnChange,
    formatDollars,
    formattedDollarsToFloat,
    THOUSANDS_PLACE_COMMAS_REGEX,
} from '../../../../../../common/utils/bankingUtils';
import PaycheckRoutingCard from '../../../common/PaycheckRoutingCard';

interface RuleAmountProps {
    amount?: number;
    updateAmount: (amount: number) => void;
    selectedRuleType: string | null;
}

const PrimaryRuleAmount = ({ amount, updateAmount }: RuleAmountProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const [formattedAmount, setFormattedAmount] = useState('');

    const formatAmount = (amount: number) => {
        if (!amount) return '$';

        const newFormattedAmount = amount
            .toString()
            .replace(THOUSANDS_PLACE_COMMAS_REGEX, ',');

        return `$${newFormattedAmount}`;
    };

    useEffect(() => {
        setFormattedAmount(formatAmount(amount ?? 0));
    }, []);

    const ref = useClickOutside<TextInput>(() => {
        setIsEditing(false);
    });

    return (
        <YStack gap={8}>
            <PaycheckRoutingCard
                onPress={() => {
                    if (!isEditing) setIsEditing(true);
                }}
            >
                {isEditing ? (
                    <XStack justifyContent="space-between" alignItems="center">
                        <XStack alignItems="center">
                            <StyledBodyMediumRegularInput
                                ref={ref}
                                keyboardType="decimal-pad"
                                padding={0}
                                value={
                                    formattedAmount === ''
                                        ? '$'
                                        : formattedAmount
                                }
                                // eslint-disable-next-line jsx-a11y/no-autofocus
                                autoFocus={true}
                                onChangeText={(incomingValue) => {
                                    const newFormattedValue =
                                        formatCurrencyInputOnChange(
                                            formatDollars(amount),
                                            incomingValue,
                                        );

                                    updateAmount(
                                        formattedDollarsToFloat(
                                            newFormattedValue,
                                        ),
                                    );
                                    setFormattedAmount(newFormattedValue);
                                }}
                                returnKeyType="done"
                                style={{
                                    width: 'auto',
                                    padding: 0,
                                    lineHeight: 20,
                                    height: 22,
                                }}
                            />
                        </XStack>
                    </XStack>
                ) : (
                    <XStack justifyContent="space-between" alignItems="center">
                        <BodyMediumRegular
                            color={amount != null ? '$black' : '$gray800'}
                        >
                            {formattedAmount === '' ? '$' : formattedAmount}
                        </BodyMediumRegular>
                    </XStack>
                )}
            </PaycheckRoutingCard>
        </YStack>
    );
};

export default PrimaryRuleAmount;
